import { TenantConfig } from "../api";
import Keycloak from "keycloak-js";
import { registerTenantInterceptor } from "./tenant-interceptor";
import { LogLevel, TenantContextValue, tenantDefaultContextValue } from "./domain";

export const generateTenantConfig = async (
  tenantData: TenantConfig,
  callbackFn?: (config: TenantContextValue) => void
) => {
  const keycloakTenantData = tenantData.keycloak;
  const keycloakConfig: Keycloak.KeycloakConfig = {
    realm: keycloakTenantData["realm"],
    url: keycloakTenantData["auth-server-url"],
    clientId: keycloakTenantData["resource"]
  };

  const config: TenantContextValue = {
    ...tenantDefaultContextValue,
    tenantId: tenantData.tenantId,
    theme: tenantData.theme || tenantDefaultContextValue.theme,
    keycloak: new Keycloak(keycloakConfig),
    keycloakConfig: keycloakConfig,
    adyen: tenantData.adyen,
    features: tenantData.features,
    urls: { ...tenantDefaultContextValue.urls, ...tenantData.urls },
    allowedBackofficeLanguages: tenantData.allowedBackofficeLanguages,
    allowedLanguages: tenantData.allowedLanguages,
    allowedLocales: tenantData.allowedLocales,
    apiKey: tenantData.apiKey,
    pwa: tenantData.pwa,
    prismic: tenantData.prismic,
    commonPrismic: tenantData.likemagicPrismic,
    toneOfVoice: tenantData.toneOfVoice,
    gtmId: tenantData.gtmId,
    googleMaps: tenantData.googleMaps,
    routesWithAuthToken:
      tenantData.routesWithAuthToken || tenantDefaultContextValue.routesWithAuthToken,
    search: tenantData.search,
    enabledCommunicationChannels: tenantData.enabledCommunicationChannels,
    additionalTravelBuddyFields: tenantData.additionalTravelBuddyFields,
    earliestCheckinOffset:
      tenantData.earliestCheckinOffset || tenantDefaultContextValue.earliestCheckinOffset,
    properties: tenantData.properties,
    keycloakNative: tenantData.keycloakNative,
    locale: tenantData.locale,
    version: tenantData.version || tenantDefaultContextValue.version,
    preferredCountries: tenantData.preferredCountries,
    logLevel: tenantData.logLevel ?? LogLevel.NONE,
    pms: tenantData.pms,
    kiosk: tenantData.kiosk || tenantDefaultContextValue.kiosk,
    secondScreenDevices:
      tenantData.secondScreenDevices || tenantDefaultContextValue.secondScreenDevices,
    disabledCountriesForIdentification: tenantData.disabledCountriesForIdentification ?? [],
    disabledCountriesForPassportUpload: tenantData.disabledCountriesForPassportUpload ?? [],
    themeOverride: tenantData.themeOverride
  };
  if (callbackFn) {
    callbackFn(config);
  }
  //Register tenant interceptor at the end so that callback happens before
  registerTenantInterceptor(tenantData.tenantId, tenantData.apiKey);

  return config;
};
